import { useNavigate } from "react-router-dom";
import { Home, ArrowLeft } from "lucide-react";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div
      className="dark min-h-screen flex flex-col items-center justify-center gap-8 text-center px-8"
      style={{ backgroundColor: "var(--lm-canvas)", fontFamily: "Inter, system-ui, sans-serif", position: "relative", overflow: "hidden" }}
    >
      {/* Ambient glow */}
      <div style={{ position: "absolute", inset: 0, pointerEvents: "none" }}>
        <div style={{
          position: "absolute", top: "20%", left: "50%", transform: "translateX(-50%)",
          width: "500px", height: "300px",
          background: "radial-gradient(ellipse, rgba(94,106,210,0.08) 0%, transparent 70%)",
          filter: "blur(60px)",
        }} />
      </div>

      <div style={{ position: "relative" }}>
        <p
          className="font-bold leading-none mb-3"
          style={{ fontSize: "clamp(80px, 15vw, 120px)", color: "#5e6ad2", letterSpacing: "-4px", opacity: 0.9 }}
        >
          404
        </p>
        <h1
          className="text-2xl font-semibold mb-2"
          style={{ color: "var(--lm-ink)", letterSpacing: "-0.5px" }}
        >
          Page introuvable
        </h1>
        <p className="text-sm max-w-xs mx-auto" style={{ color: "var(--lm-ink-2)", lineHeight: 1.6 }}>
          La page que vous cherchez n&apos;existe pas ou a été déplacée.
        </p>
      </div>

      <div className="flex gap-3" style={{ position: "relative" }}>
        <button
          onClick={() => navigate(-1)}
          className="inline-flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-colors"
          style={{ color: "var(--lm-ink-2)", backgroundColor: "var(--lm-s1)", border: "1px solid var(--lm-border)" }}
          onMouseEnter={(e) => { e.currentTarget.style.color = "var(--lm-ink)"; e.currentTarget.style.borderColor = "var(--lm-border-2)"; }}
          onMouseLeave={(e) => { e.currentTarget.style.color = "var(--lm-ink-2)"; e.currentTarget.style.borderColor = "var(--lm-border)"; }}
        >
          <ArrowLeft className="h-4 w-4" />
          Retour
        </button>
        <button
          onClick={() => navigate("/dashboard")}
          className="inline-flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-colors"
          style={{ backgroundColor: "#5e6ad2", color: "#ffffff", border: "none" }}
          onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#828fff")}
          onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#5e6ad2")}
        >
          <Home className="h-4 w-4" />
          Tableau de bord
        </button>
      </div>
    </div>
  );
};

export default NotFound;
